export const FinishedState = Object.freeze({
  NOT_STARTED: 'notstarted',
  STARTED: 'started',
  FINISHED: 'finished'
});
